{
  "title": "Hisob",
  "registerTitle": "Ro‘yxatdan o‘tish",
  "subtitle": "Email, Google, telefon yoki Telegram orqali kiring - har bir usul bitta hisob va hamyonni ochadi.",
  "email": "Email",
  "password": "Parol",
  "showPassword": "Ko‘rsatish",
  "hidePassword": "Yashirish",
  "acceptTerms": "Foydalanish qoidalariga roziman",
  "registerCta": "Ro‘yxatdan o‘tish",
  "haveAccount": "Hisobingiz bormi?",
  "needAccount": "Hisob yo‘qmi?",
  "telegramHint": "Telegram Mini App avtomatik kirishi yoqilgan (initData serverda tekshiriladi).",
  "unavailable": "Autentifikatsiya hali faol emas",
  "telegramSoon": "Telegram orqali kirish tez orada",
  "webSoon": "Veb kirish tez orada",
  "googleDisabled": "Google login disabled until OAuth is configured",
  "googleReady": "Continue with Google",
  "smsDisabled": "SMS login disabled until an SMS provider is configured",
  "smsReady": "Continue with phone",
  "orEmail": "Email",
  "registerShort": "Royxat",
  "loginTitle": "Kirish",
  "tabEmail": "Email",
  "tabPhone": "Telefon",
  "emailPlaceholder": "E-mail",
  "phoneUnavailableTitle": "Telefon orqali kirish hozircha faol emas",
  "phoneUnavailableBody": "SMS xizmati ulanmagan. Email va parol bilan davom eting.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "Ozarbayjonning 9 xonali mobil raqamini kiriting (masalan, 50 123 45 67).",
  "casinoBonusInactive": "Kampaniya hali faol emas",
  "socialMethods": "Ijtimoiy kirish",
  "orContinue": "yoki",
  "continueWithTelegram": "Telegram orqali davom et",
  "casinoBonus": "Kazino bonusi",
  "noRegistrationBonus": "Hozir ro'yxatdan o'tishda tanlanadigan bonus yo'q.",
  "promoToggle": "Promo kod qo'shish",
  "promoPlaceholder": "Promo kod",
  "promoHint": "Kod ro'yxatdan o'tishda avtomatik qo'llanmaydi. Keyin Bonuslar sahifasida kiritishingiz mumkin.",
  "acceptTermsPrefix": "Men ",
  "acceptTermsLink": "foydalanish qoidalarini",
  "acceptTermsSuffix": " o'qidim va roziman.",
  "acceptTermsRequired": "Ro'yxatdan o'tish uchun qoidalarga rozilik kerak.",
  "termsMissingNote": "Qoidalar qoralamasi /qaydalar sahifasida. Nashr uchun alohida ruxsat kerak. Ro‘yxatdan o‘tish uchun belgilang.",
  "registerSubmit": "Ro'yxatdan o'tish",
  "loginSubmit": "Kirish",
  "socialSoon": "Google va Telegram veb kirish hozircha faol emas.",
  "haveAccountPrompt": "Hisobim bormi?",
  "haveAccountAction": "Kirish",
  "needAccountPrompt": "Hisob kerakmi?",
  "needAccountAction": "Ro'yxat",
  "resetPassword": "Parolni tiklash",
  "closeDialog": "Yopish",
  "forgotLink": "Parolni unutdingizmi?",
  "forgotTitle": "Parolni tiklash",
  "forgotIntro": "Hisobingiz emailini kiriting. Agar u ro'yxatdan o'tgan bo'lsa, tiklash havolasini yuboramiz.",
  "forgotCta": "Havolani yuborish",
  "forgotSent": "Agar ushbu email bilan hisob mavjud bo'lsa, havola yuborildi. Kiruvchi va spam papkalarini tekshiring.",
  "sendAgain": "Qayta yuborish",
  "emailDeliveryOff": "Ushbu serverda email yuborish hali sozlanmagan, xat kelmaydi.",
  "backToLogin": "Kirishga qaytish",
  "resetTitle": "Yangi parol tanlang",
  "newPassword": "Yangi parol",
  "confirmPassword": "Parolni takrorlang",
  "passwordsDontMatch": "Parollar mos kelmaydi",
  "passwordRules": "Kamida 8 belgi: harflar bilan birga raqam yoki belgilar.",
  "resetCta": "Yangi parolni saqlash",
  "resetDone": "Parol o'zgartirildi. Barcha seanslar yopildi - yangi parol bilan kiring.",
  "linkInvalid": "Havola yaroqsiz, muddati o'tgan yoki allaqachon ishlatilgan.",
  "requestNewLink": "Yangi havola so'rash",
  "checking": "Tekshirilmoqda...",
  "verifyTitle": "Emailni tasdiqlash",
  "verifyIntro": "Email manzilingizni tasdiqlash uchun tugmani bosing.",
  "verifyCta": "Emailni tasdiqlash",
  "verifyDone": "Email tasdiqlandi. Rahmat!",
  "verifyResendHint": "Yangi tasdiqlash xatini «Xavfsizlik» sahifasida so'rashingiz mumkin.",
  "securityTitle": "Hisob xavfsizligi",
  "emailVerified": "Tasdiqlangan",
  "emailNotVerified": "Tasdiqlanmagan",
  "resendVerification": "Tasdiqlash xatini qayta yuborish",
  "verificationSent": "Tasdiqlash xati yuborildi.",
  "verificationSentAfterRegister": "Hisob yaratildi. Emailingizga tasdiqlash havolasini yubordik.",
  "phoneTitle": "Telefon orqali kirish",
  "phoneLinkTitle": "Telefon raqamini qo'shish",
  "phoneLabel": "Telefon raqami",
  "phoneHint": "Ozarbayjon raqamlarini 050 123 45 67 ko'rinishida yozish mumkin. Boshqa davlatlar uchun + bilan boshlang.",
  "sendCode": "Kodni yuborish",
  "codeLabel": "SMS dagi kod",
  "codeSentTo": "{{phone}} raqamiga 6 xonali kod yubordik.",
  "verifyCode": "Tasdiqlash",
  "resendCode": "Kodni qayta yuborish",
  "resendIn": "{{seconds}} soniyadan keyin qayta yuborish",
  "changeNumber": "Raqamni o'zgartirish",
  "phoneLinked": "Telefon raqami qo'shildi.",
  "googleWorking": "Google orqali kirilmoqda...",
  "telegramWorking": "Telegram orqali kirilmoqda...",
  "telegramCancelled": "Telegram orqali kirish bekor qilindi.",
  "googleLinked": "Google hisobi bog'landi.",
  "googleCancelled": "Google orqali kirish bekor qilindi.",
  "signInToLink": "Hisobingizga kiring",
  "telegramWidgetUnavailable": "Saytda Telegram orqali kirish bot domeni sozlangandan keyin mavjud bo'ladi. Telegram ichida Mini App sizni avtomatik kiritadi.",
  "telegramLinked": "Telegram bog'landi.",
  "signInRequired": "Hisob xavfsizligini boshqarish uchun kiring.",
  "loginMethods": "Kirish usullari",
  "methodPassword": "Email va parol",
  "methodGoogle": "Google",
  "methodPhone": "Telefon (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Bog'langan",
  "notLinked": "Bog'lanmagan",
  "link": "Bog'lash",
  "unlink": "Uzish",
  "unlinked": "Kirish usuli olib tashlandi.",
  "lastMethodHint": "Yagona kirish usulini olib tashlab bo'lmaydi.",
  "unavailableProvider": "Sozlanmagan",
  "changePasswordTitle": "Parolni o'zgartirish",
  "setPasswordTitle": "Parol o'rnatish",
  "currentPassword": "Joriy parol",
  "savePassword": "Parolni saqlash",
  "passwordSaved": "Parol saqlandi. Boshqa seanslar yopildi.",
  "changeEmailTitle": "Emailni o'zgartirish",
  "newEmail": "Yangi email",
  "saveEmail": "Emailni saqlash",
  "emailSaved": "Email yangilandi. Yangi manzilni xatdan tasdiqlang.",
  "reauthTitle": "Bu siz ekanligingizni tasdiqlang",
  "reauthIntro": "Xavfsizlik uchun davom etishdan oldin parolingizni kiriting.",
  "reauthPasswordless": "Xavfsizlik uchun davom etishdan oldin qayta kiring.",
  "reauthCta": "Davom etish",
  "mfaCode": "Autentifikator kodi",
  "signInAgain": "Qayta kirish",
  "sessionsTitle": "Seanslar",
  "logout": "Chiqish",
  "logoutAll": "Barcha qurilmalardan chiqish",
  "phoneNotSet": "Telefon raqami yo'q",
  "errors": {
    "invalid_credentials": "Email yoki parol noto'g'ri.",
    "too_many_requests": "Urinishlar juda ko'p. Biroz kutib, qayta urinib ko'ring.",
    "email_taken": "Bu email allaqachon ro'yxatdan o'tgan. Hisobga kiring.",
    "password_too_short": "Parol juda qisqa (kamida 8 belgi).",
    "password_too_long": "Parol juda uzun (ko'pi bilan 128 belgi).",
    "password_too_weak": "Parol zaif. Harflarni raqam yoki belgilar bilan aralashtiring.",
    "password_too_common": "Bu parol juda keng tarqalgan. Boshqasini tanlang.",
    "password_contains_email": "Parolda email nomingiz bo'lmasligi kerak.",
    "invalid_or_expired_token": "Havola yaroqsiz, muddati o'tgan yoki allaqachon ishlatilgan.",
    "invalid_password": "Parol noto'g'ri.",
    "invalid_email": "To'g'ri email kiriting.",
    "email_not_set": "Hisobda email yo'q.",
    "reauth_required": "Davom etish uchun bu siz ekanligingizni tasdiqlang.",
    "password_not_set": "Bu hisobda parol yo'q. Bog'langan usul bilan qayta kiring.",
    "email_required_for_password": "Parol o'rnatishdan oldin email qo'shing.",
    "email_delivery_unavailable": "Email yuborish hali sozlanmagan.",
    "sms_disabled": "SMS orqali kirish hali mavjud emas.",
    "phone_auth_disabled": "Telefon orqali ro‘yxatdan o‘tish va SMS kirish vaqtincha o‘chirilgan.",
    "sms_delivery_failed": "SMS yuborilmadi. Keyinroq qayta urinib ko'ring.",
    "invalid_phone": "To'g'ri telefon raqamini kiriting.",
    "resend_cooldown": "Yangi kod so'rashdan oldin biroz kuting.",
    "otp_invalid": "Kod noto'g'ri yoki muddati o'tgan.",
    "otp_expired": "Kod muddati o'tdi. Yangisini so'rang.",
    "otp_attempts_exceeded": "Noto'g'ri kodlar juda ko'p. Yangi kod so'rang.",
    "phone_in_use": "Bu raqam boshqa hisobga tegishli.",
    "phone_signin_conflict_retry": "Qayta urinib ko'ring.",
    "google_oauth_disabled": "Google orqali kirish hali mavjud emas.",
    "telegram_oidc_disabled": "Telegram orqali veb-kirish hali mavjud emas.",
    "google_account_exists_link_required": "Ushbu Google emaili bilan hisob mavjud. Avval unga kiring, so'ng «Xavfsizlik» sahifasida Google'ni bog'lang.",
    "google_linked_to_other_account": "Bu Google hisobi boshqa VBB PLAY hisobiga bog'langan.",
    "google_other_account_linked": "Boshqa Google hisobi allaqachon bog'langan. Avval uni uzing.",
    "google_signin_conflict_retry": "Qayta urinib ko'ring.",
    "invalid_state": "Kirish urinishi muddati o'tdi yoki boshqa brauzerda boshlangan. Qayta urinib ko'ring.",
    "state_expired": "Kirish urinishi muddati o'tdi. Qayta urinib ko'ring.",
    "nonce_mismatch": "Google orqali kirishni tekshirib bo'lmadi. Qayta urinib ko'ring.",
    "invalid_id_token": "Google orqali kirishni tekshirib bo'lmadi. Qayta urinib ko'ring.",
    "token_exchange_failed": "Google kirishni tasdiqlamadi. Qayta urinib ko'ring.",
    "signing_key_unavailable": "Google vaqtincha mavjud emas. Qayta urinib ko'ring.",
    "link_session_mismatch": "Bog'lashni boshlagan hisobga kiring.",
    "telegram_already_linked": "Bu Telegram boshqa VBB PLAY hisobiga bog'langan.",
    "telegram_other_account_linked": "Boshqa Telegram allaqachon bog'langan. Avval uni uzing.",
    "telegram_payload_required": "Telegram kirish ma'lumotlarini bermadi.",
    "auth_data_replayed": "Bu Telegram kirishi allaqachon ishlatilgan. Qayta kiring.",
    "auth_data_expired": "Telegram kirishi muddati o'tdi. Qayta urinib ko'ring.",
    "invalid_hash": "Telegram orqali kirishni tekshirib bo'lmadi.",
    "last_login_method": "Yagona kirish usulini olib tashlab bo'lmaydi.",
    "account_suspended": "Hisob to'xtatilgan. Qo'llab-quvvatlash xizmatiga murojaat qiling.",
    "admin_email_change_disabled": "Administrator emailini faqat operator o'zgartira oladi.",
    "mfa_required": "Autentifikator ilovasidagi kodni kiriting."
  }
}
